import { type I18n } from 'vue-i18n';

class TranslationService {
    public overrideTranslations(i18n: I18n, overrides: Object) {
        const defaults = (i18n.global.messages as any).value;
        const locales = ['nl', 'en', 'de', 'fr', 'es', 'it', 'sv', 'da', 'fy_NL'];

        locales.forEach((locale) => {
            const messages = defaults[locale] ? defaults[locale] : defaults['en'];
            const localeOverrides = (overrides as any)[locale] || {};

            Object.keys(localeOverrides).forEach((key) => {
                const value = localeOverrides[key];

                if (undefined === messages[key]) {
                    console.warn('translation with key ' + key + ' does not exist');
                } else {
                    messages[key] = value;
                }
            });

            i18n.global.setLocaleMessage(locale, messages);
        });
    }

    public parseAttribute(i18n: any, attribute: string) {
        try {
            const overrideTranslations = JSON.parse(attribute);
            this.overrideTranslations(i18n, overrideTranslations);
        } catch (e) {
            throw 'Failed to parse translations param: ' + attribute;
        }
    }
}

export default new TranslationService();
